// extracted by css-extract-rspack-plugin
var _1 = "f8";
export { _1 as "logoTileComponent" }
